import type { AuthLocks } from './environment';

/**
 * Задача под Web Lock `name` — одна на все вкладки origin: параллельные ротации одним refresh сервер считает reuse и
 * выкидывает обе вкладки. Без Web Locks (`locks` = null) — сразу; single-flight внутри вкладки — забота вызывающего.
 */
export function runExclusive<T>(locks: AuthLocks | null, name: string, task: () => Promise<T>): Promise<T> {
    return locks ? locks.request(name, () => task()) : task();
}
